import React from "react";
import { ArrowLeft } from "lucide-react";

export default function FinalCTA() {
  const scrollToForm = () => document.querySelector("#register")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="py-20 md:py-32 relative">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="relative rounded-[2.5rem] glass overflow-hidden p-10 md:p-16 text-center">
          <div className="absolute inset-0 -z-10 grid-pattern opacity-30" />
          <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] bg-purple-600/25 blur-[160px] rounded-full pointer-events-none" />
          <div className="absolute -bottom-20 left-1/2 -translate-x-1/2 w-[28rem] h-[28rem] bg-cyan-500/15 blur-[140px] rounded-full pointer-events-none" />

          {/* sound wave decoration */}
          <div className="flex items-end justify-center gap-1 mb-6 h-12" aria-hidden>
            {[14, 22, 32, 26, 40, 36, 48, 30, 22, 36, 28, 18, 30, 24, 16].map((h, i) => (
              <div
                key={i}
                className="w-1.5 rounded-full bg-gradient-to-t from-purple-500 to-cyan-300 opacity-80"
                style={{ height: `${h}px`, animation: `float ${2 + (i % 4)}s ease-in-out ${i * 0.05}s infinite` }}
              />
            ))}
          </div>

          <h2 className="text-3xl md:text-5xl font-black tracking-tight">
            آماده‌ای موزیکت رو <span className="gradient-text-neon">جهانی</span> منتشر کنی؟
          </h2>
          <p className="mt-5 text-slate-300 max-w-2xl mx-auto leading-relaxed">
            فرم همکاری را تکمیل کن تا شرایط انتشار، هزینه، زمان‌بندی و نحوه دریافت درآمدت بررسی شود.
          </p>

          <button onClick={scrollToForm} data-testid="final-cta" className="mt-8 btn-primary text-base">
            شروع همکاری
            <ArrowLeft className="w-4 h-4" />
          </button>

          <p className="mt-5 text-sm text-slate-400">
            انتشار جهانی، دریافت درآمد در ایران، پشتیبانی فارسی.
          </p>
        </div>
      </div>
    </section>
  );
}
